function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1142 -259)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m1165.957 264 7.293 7.293V294h-23.5v-30h16.207zm-.707 1h-14.5v28h21.5v-21h-7v-7zm-6.595 14.32c1.31 0 2.03.77 2.03 2.4s-.73 2.41-2.03 2.41c-.5 0-.94-.16-1.18-.43v1.77c0 .3-.24.54-.54.54-.3 0-.54-.24-.54-.54v-5.55c0-.3.24-.54.54-.54.3 0 .54.24.54.54.15-.25.62-.6 1.18-.6zm6.29-2.44c.3 0 .54.24.54.54v4.71c0 1.33-.86 2-2.07 2-1.35 0-2.14-.77-2.14-2.4s.77-2.41 2.03-2.41c.48 0 .9.2 1.1.4v-2.3c0-.3.24-.54.54-.54zm-10.22 5.88c.42 0 .65.22.65.67 0 .44-.23.65-.65.65-.42 0-.66-.21-.66-.65 0-.45.24-.67.66-.67zm13.94-5.61a.47.47 0 1 1 0 .94c-.55 0-.83.31-.83.75v.62h.67c.25 0 .45.2.45.45s-.2.45-.45.45h-.67v3.2c0 .3-.24.52-.54.52-.32 0-.54-.22-.54-.52v-3.2h-.21c-.25 0-.45-.2-.45-.45s.2-.45.45-.45h.21v-.54c0-.93.62-1.77 1.91-1.77zm-10.15 3.09c-.7 0-1.07.5-1.07 1.49 0 .98.37 1.48 1.07 1.48.7 0 1.07-.5 1.07-1.48 0-.99-.37-1.49-1.07-1.49zm4.9 0c-.68 0-1.07.5-1.07 1.49 0 .98.38 1.48 1.07 1.48.58 0 .99-.39.99-1.08v-1.38s-.39-.51-.99-.51zm2.835-14.533V271h5.293l-5.293-5.293z",
  fill: "currentColor"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pdf.d01eec55.svg";
export { SvgComponent as ReactComponent };